// Round U — who a question is for, and which question the welcome card offers. Pure helpers.
const norm = (s) => (s || "").trim().toLowerCase();

export const isForMe = (q, title) => {
  const funcs = q?.functies || [];
  if (!funcs.length) return true;
  const t = norm(title);
  return !!t && funcs.some((f) => norm(f) === t);
};

const isTargetedAtMe = (q, title) => (q?.functies || []).length > 0 && isForMe(q, title);

// "Vraag voor: Administratie" on a question for another functie; null on my own or general questions.
export const functieLabel = (q, title) => {
  const mine = typeof q?.for_me === "boolean" ? q.for_me : isForMe(q, title);
  if (mine) return null;
  const funcs = (q?.functies || []).map((f) => (f || "").trim()).filter(Boolean);
  if (!funcs.length) return null;
  const extra = funcs.length > 2 ? ` +${funcs.length - 2}` : "";
  return `Vraag voor: ${funcs.slice(0, 2).join(" · ")}${extra}`;
};

// Targeted at me + nobody answered → targeted at me + open for me → general nobody answered → general open.
// Never a question for another functie.
export const pickStarterQuestion = (questions, title) => {
  const list = (questions || []).filter((q) => q && !q.answered);
  const nobody = (q) => q.has_memo !== true;
  const targeted = list.filter((q) => isTargetedAtMe(q, title));
  const general = list.filter((q) => !(q.functies || []).length);
  return targeted.find(nobody) || targeted[0] || general.find(nobody) || general[0] || null;
};

export const firstName = (name) => (name || "").trim().split(/\s+/)[0] || "";

export const WELCOME_BACK_DAYS = 14;

export const daysSince = (iso, now = Date.now()) => {
  const t = iso ? Date.parse(iso) : NaN;
  return Number.isFinite(t) ? Math.floor((now - t) / 86400000) : null;
};

// "first" for a user without memos, "back" when the last memo is 14 days or older, else null.
export const starterMode = ({ isStarter, totalMemos, lastMemoAt, role, now = Date.now() }) => {
  if (role === "lezer") return null;
  if (isStarter) return "first";
  const days = daysSince(lastMemoAt, now);
  return totalMemos >= 1 && days !== null && days >= WELCOME_BACK_DAYS ? "back" : null;
};

export const starterTexts = ({ mode, user, question }) => {
  const name = firstName(user?.name);
  const functie = (user?.title || "").trim();
  const targeted = !!question && isTargetedAtMe(question, functie);
  if (mode === "back") {
    return { title: name ? `Welkom terug, ${name}.` : "Welkom terug.",
      body: targeted ? "Er staat een vraag klaar over jouw werk." : "Er staat een vraag voor je klaar." };
  }
  if (!functie) return { title: "Begin met één vraag.", body: "Dertig seconden is genoeg." };
  return { title: name ? `Welkom, ${name}.` : "Welkom.",
    body: targeted ? `Deze vraag is speciaal voor jouw werk als ${functie}. Dertig seconden is genoeg.` : "Dertig seconden is genoeg." };
};

export const todayKey = (now = new Date()) =>
  `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;


// Round U fix — after a save, the saved question counts as answered locally (no later pick offers it again).
export const markQuestionAnswered = (questions, saved) => {
  if (!saved || !Array.isArray(questions)) return questions;
  return questions.map((q) => (q.id === saved.id || (saved.text && q.text === saved.text) ? { ...q, answered: true } : q));
};
